import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Heading from '@bibliocommons/heading';
import { ChevronLink } from '@bibliocommons/base-links';

import { BackToLinkManager } from 'app/components/BackToLinkManager';
import displayBibShape from 'app/shapes/displayBib';
import DisplayBibSlide from 'app/components/browse/shared/BibsRowBibs/DisplayBibSlide'; // TODO: refactor to prevent Events using Browse page component

import './RelatedDisplayBibs.scss';

export default function RelatedDisplayBibs({
  currentPageHref,
  displayBibs,
  headingId,
  searchTerm,
  trackCatalogTitleClick = () => null
}) {
  return (
    <div className="cp-event-related-display-bibs">
      <BackToLinkManager href={currentPageHref} pageId="events" />
      <Heading tagName="h2" size="moderate" variant>
        <FormattedMessage id={headingId} />
      </Heading>
      <ul className="bib-titles-row">
        {displayBibs.map(displayBib => (
          <li className="bibs-row-item" key={displayBib.metadataId}>
            <DisplayBibSlide
              className="bibs-row-slide"
              displayBib={displayBib}
              trackClick={() => trackCatalogTitleClick({ displayBib })}
            />
          </li>
        ))}
      </ul>
      {searchTerm && (
        <ChevronLink href={`/v2/search?query=${searchTerm}&searchType=smart`} dataKey="view-all-results-link">
          <FormattedMessage id="events.view.results" />
        </ChevronLink>
      )}
    </div>
  );
}

RelatedDisplayBibs.propTypes = {
  currentPageHref: PropTypes.string.isRequired,
  displayBibs: PropTypes.arrayOf(displayBibShape),
  headingId: PropTypes.string.isRequired,
  searchTerm: PropTypes.string,
  trackCatalogTitleClick: PropTypes.func
};
